import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { shareOnFacebook } from 'utils/share';

class JournalHeader extends React.Component {

    render () {
        var self = this,
            checkin = self.props.checkin,
            photos = checkin.place != null ? checkin.place.photos : null,
            url,
            style;

        if (photos != null && photos.length) {
            url = photos[checkin.selectedPhotoIndex != null ? checkin.selectedPhotoIndex: 0];

            style = { 
                backgroundImage: `url(${url})`
            };
        }

        return (
            <div className="journal-entry-header-container">
                <Link to={ `/journal/${checkin.id}` }><h2 className="journal-entry-header-text">{ checkin.summary }</h2></Link>
                <div className="journal-entry-header-background" style={ style } />

                <div className="journal-entry-header-actions">
                    <a className="btn btn-primary" href="javascript:void(0)" alt="Share on Facebook" title="Share on Facebook" onClick={ () => shareOnFacebook(checkin) }>
                        <i className="fa fa-facebook"></i>
                    </a>
                </div>
            </div>
        );
    }
};

export default JournalHeader;


// WEBPACK FOOTER //
// ./src/app/components/journal/journalHeader.jsx